import { IonButton, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { userService } from '../services/userService';
import { useUserDataState } from '../utilities/hooks';
import { Md5 } from 'ts-md5';

const logon: React.FC<{setLoggedIn: (loggedIn: boolean) => void}> = ({setLoggedIn}) => {
  const loginDemo = 'demo';
  const passwordDemo = 'password';
  const [login, setLogin] = useUserDataState('login', loginDemo);
  const [pass, setPass] = useState(passwordDemo);
  const [password, setPassword] = useUserDataState('passwd', Md5.hashStr(passwordDemo));
  const [authorization, setAuthorization] = useUserDataState('authorization', false);
  const history = useHistory();

  const setPasswd = (password?: string | null) => {
    if (authorization) {
      setAuthorization(false);
    }
    const pass = password ?? '';
    setPass(pass);
    setPassword(Md5.hashStr(pass));
  };

  const logon = () => {
    if (userService.checkValidation(login, password)) {
      setAuthorization(true);
      setLoggedIn(true);
      history.goBack();
      return;
    }
    // eslint-disable-next-line no-alert
    window.alert('Incorrect login details');
    return;
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large">
            Welcome in PCMA
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonItem lines={'none'}>
          <h5>Please log in.</h5>
        </IonItem>
        <IonItem>
          <IonLabel>
            Login:
          </IonLabel>
          <IonInput value={login} onIonChange={(event) => setLogin(`${event.detail.value}`)} />
        </IonItem>
        <IonItem>
          <IonLabel>
            Password:
          </IonLabel>
          <IonInput type='password' value={pass} onIonChange={(event) => setPasswd(`${event.detail.value}`)} />
        </IonItem>
        <IonButton expand='full' onClick={logon}>
          Login
        </IonButton>
      </IonContent>
    </IonPage>
  );
};

export { logon as Logon };
